import { Apollo } from 'apollo-angular';
import { IActionCenterLinker } from '../../interfaces';
import { ILinkLabelsVariables } from './linking-interfaces';
import { firstValueFrom, timeout } from 'rxjs';
import { linkLabelsActionCenter } from './mutations';
import { LinkIncidentsMutation } from '@app/pages/cmms/graphql/incident.mutations';

import { IRequest } from '@app/pages/cmms/interfaces/request.interfaces';
import { IWorkOrder } from '@app/domain/cmms-types/workorder-types';

export class IncidentLabelLinker implements IActionCenterLinker<string> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: string[]): Promise<any> {
		const variables: ILinkLabelsVariables = {
			incidentIds: selectedPks,
			labelIds: targets,
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: linkLabelsActionCenter, variables })
				.pipe(timeout(5000))
		);
	}
}

export class IncidentStatusLinker implements IActionCenterLinker<string> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: string[]): Promise<any> {
		const variables = {
			incidents: selectedPks,
			status: targets[0],
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: LinkIncidentsMutation, variables })
				.pipe(timeout(5000))
		);
	}
}

export class IncidentPriorityLinker implements IActionCenterLinker<string> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: string[]): Promise<any> {
		const variables = {
			incidents: selectedPks,
			priority: targets[0],
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: LinkIncidentsMutation, variables })
				.pipe(timeout(5000))
		);
	}
}

export class IncidentCategoryLinker implements IActionCenterLinker<string> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: string[]): Promise<any> {
		const variables = {
			incidents: selectedPks,
			category: targets[0],
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: LinkIncidentsMutation, variables })
				.pipe(timeout(5000))
		);
	}
}

export class IncidentWorkOrderLinker implements IActionCenterLinker<IWorkOrder> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: IWorkOrder[]): Promise<any> {
		const variables = {
			incidents: selectedPks,
			workOrders: targets.map(target => target.pk),
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: LinkIncidentsMutation, variables })
				.pipe(timeout(5000))
		);
	}
}

export class IncidentRequestLinker implements IActionCenterLinker<IRequest> {
	private readonly apollo: Apollo;

	constructor(deps: { apollo: Apollo }) {
		this.apollo = deps.apollo;
	}

	async link(selectedPks: string[], targets: IRequest[]): Promise<any> {
		const variables = {
			incidents: selectedPks,
			requests: targets.map(target => target.pk),
		};
		return await firstValueFrom(
			this.apollo
				.mutate({ mutation: LinkIncidentsMutation, variables })
				.pipe(timeout(5000))
		);
	}
}
